import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLookNameToShellName = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 9C4.65113 9 6 7.69137 6 6.08992C6 4.1559 3 1 3 1C3 1 0 4.1559 0 6.08992C0 7.69137 1.34887 9 3 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.34866 10.0156L2.92338 10.016C2.96554 10.0161 2.99999 10.05 2.99996 10.0915L3.00005 12.5188L4.50107 12.5191L4.50157 11.8319C4.50162 11.7688 4.57636 11.733 4.62614 11.7726L5.98459 12.828C5.99375 12.835 6.00115 12.844 6.00624 12.8543C6.01133 12.8646 6.01396 12.8758 6.01395 12.8873C6.01394 12.8987 6.01129 12.91 6.00619 12.9203C6.00109 12.9306 5.99367 12.9396 5.98451 12.9466L4.6245 13.9999C4.5737 14.0395 4.49997 14.0037 4.50002 13.9406L4.50054 13.2346L2.88458 13.2342C2.54645 13.234 2.27173 12.9636 2.27197 12.6313V10.0909C2.272 10.0494 2.30651 10.0156 2.34866 10.0156Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.06 1H12.94C12.973 1 13 1.0375 13 1.08333V1.91667C13 1.9625 12.973 2 12.94 2H7.06C7.027 2 7 1.9625 7 1.91667V1.08333C7 1.0375 7.027 1 7.06 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.03 3H9.97C9.9865 3 10 3.0375 10 3.08333V3.91667C10 3.9625 9.9865 4 9.97 4H7.03C7.0135 4 7 3.9625 7 3.91667V3.08333C7 3.0375 7.0135 3 7.03 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.03 15H17.97C17.9865 15 18 15.0375 18 15.0833V15.9167C18 15.9625 17.9865 16 17.97 16H15.03C15.0135 16 15 15.9625 15 15.9167V15.0833C15 15.0375 15.0135 15 15.03 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.05 17H17.95C17.9775 17 18 17.0375 18 17.0833V17.9167C18 17.9625 17.9775 18 17.95 18H13.05C13.0225 18 13 17.9625 13 17.9167V17.0833C13 17.0375 13.0225 17 13.05 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.9138 7.84809L16.7983 11.9283C16.9639 12.0883 16.9639 12.356 16.7983 12.5273L9.9138 17.7216C9.74824 17.8929 9.48071 17.9021 9.31515 17.7421L5.95906 14.7888L6.81652 13.9948L9.61447 16.4669L15.3184 12.3059L9.61447 9L6.88921 11.3909L6.1538 10.6669L9.31515 7.86856C9.48071 7.69724 9.74824 7.68809 9.9138 7.84809Z",
			fill: "currentColor"
		})
	]
});
export default SvgLookNameToShellName;
